// extracted by mini-css-extract-plugin
export default {"Label":"aggregate-labels-module__Label__EAndo8X","default":"aggregate-labels-module__default__os4OW0V","danger":"aggregate-labels-module__danger__UJ1NMHt"};